class AppState {
	// public
	classes = $state<ClassRecord[]>([])
	locations = $state<StudioLocation[]>([])
	products = $state<Product[]>([])
	schedule = $state<ScheduledClass[]>([])
	teachers = $state<Teacher[]>([])
	workshops = $state<Workshop[]>([])
	clientToken = $state('') // Braintree
	loginMessage = $state('')
	formInvalid = $state(false)
	// cloudFlareTurnstileToken = $state('')

	user = $state<User>(null)
	orderConfirmation = $state<Order>({
		payment: {
			date: new Date(),
			amount: '0.00',
			cardType: 'unknown',
			expirationDate: '',
			maskedNumber: '',
			nonce: undefined,
			id: ''
		},
		items: [],
		customer: {
			id: 0,
			firstName: '',
			lastName: '',
			email: '',
			phone: ''
		},
		isGift: false,
		sendVia: 'email',
		recipient: {
			id: 0,
			firstName: '',
			lastName: '',
			email: '',
			phone: '',
			address: {
				firstName: '',
				lastName: '',
				streetAddress: '',
				city: '',
				state: '',
				zipCode: ''
			}
		},
		giftMessage: '',
		instructions: ''
	})
	selectedClass = $state<SelectedClass>()

	showToast = $state<(toast: Toast) => void>(() => {})

	// admin
	classesAll = $state<ClassRecord[]>([])
	dashboardData = $state<Dashboard>({
		attendanceRevenue: [],
		attendanceLocation: [],
		popularProducts: [],
		popular: [],
		unpopular: [],
		teachers: [],
		teacherPay: []
	})
	locationsAll = $state<StudioLocation[]>([])
	teachersCurrent = $state<Teacher[]>([])

	initializePublic(master: MasterData) {
		this.classes = master.classes
		this.locations = master.locations
		this.products = master.products
		this.schedule = master.schedule
		this.teachers = master.teachers
		this.workshops = master.workshops
		this.clientToken = master.clientToken
	}

	initializeAdmin(admin: AdminData) {
		this.classesAll = admin.classesAll
		this.dashboardData = admin.dashboardData
		this.locationsAll = admin.locationsAll
		this.teachersCurrent = admin.teachersCurrent
	}
}

export const appState = new AppState()
